import { render, staticRenderFns } from "./ConsultasIndex.vue?vue&type=template&id=0add55bc"
import script from "./ConsultasIndex.vue?vue&type=script&lang=js"
export * from "./ConsultasIndex.vue?vue&type=script&lang=js"
import style0 from "./ConsultasIndex.vue?vue&type=style&index=0&id=0add55bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports